jQuery(document).ready(function ($) {
  if (Shopify.locale == "fr") {
    var mylist = $("#HeaderMenu-SubMenuList-2");
    var listitems = mylist.children("li").get();
    listitems.sort(function (a, b) {
      return $(a).text().toUpperCase().localeCompare($(b).text().toUpperCase());
    });
    $.each(listitems, function (idx, itm) {
      mylist.append(itm);
    });
  }
});
